<template>
  <div class="container-fluid">
    <table class="xz-table">
      <thead>
      <tr>
        <th class="bold">Refusjon</th>
        <th class="bold">Antall</th>
        <th class="bold"></th>
        <th class="bold">Beløp</th>
      </tr>
      </thead>
      <tbody>

      <tr v-if="totalRefundCashCount > 0">
        <td>Kontant</td>
        <td>{{totalRefundCashCount}}</td>
        <td></td>
        <td>{{ displayTwoDecimals(totalRefundCashTotalAmount) }}</td>
      </tr>

      <tr v-if="totalRefundCardCount + unclassifiedRefundCount > 0">
        <td>Kredittkort</td>
        <td>{{totalRefundCardCount + unclassifiedRefundCount}}</td>
        <td></td>
        <td>{{ displayTwoDecimals(totalRefundCardTotalAmount + unclassifiedRefundAmount) }}</td>
      </tr>

      <tr v-if="totalRefundBankAxeptCount > 0">
        <td>BankAxept</td>
        <td>{{totalRefundBankAxeptCount}}</td>
        <td></td>
        <td>{{ displayTwoDecimals(totalRefundBankAxeptTotalAmount) }}</td>
      </tr>

      <tr v-if="totalRefundBonusCount > 0">
        <td>Bonuspoeng</td>
        <td>{{totalRefundBonusCount}}</td>
        <td></td>
        <td>{{ displayTwoDecimals(totalRefundBonusTotalAmount) }}</td>
      </tr>

      <tr>
        <td class="bold">Total refusjon</td>
        <td class="bold">{{totalRefundPaymentsCount}}</td>
        <td></td>
        <td class="bold">{{ displayTwoDecimals(totalRefundReceiptsTotalAmount) }}</td>
      </tr>

      </tbody>
    </table>
    <div v-if="saftSource && totalRefundReceiptsCount > 0" class="saft-info-notice">
      SAF-T inneholder kun totalbeløp for refusjon. Fordeling per betalingsmiddel er ikke tilgjengelig.
    </div>
    <hr class="horizontal-dashed"/>
  </div>
</template>

<script>
import MathUtil from "@/util/MathUtil";

export default {
  props: {
    zReports: Array,
    vat: Object,
    saftSource: { type: Boolean, default: false }
  },
  computed: {
    totalRefundReceiptsCount(){
      var count = 0;
      for (var i = 0; i < this.zReports.length; i++) {
        count = count + this.zReports[i].cagistahospitality.refundReceiptsCount;
      }
      return count;
    },
    /** The payments paid back, the rows above added up, as «Total salg» counts payments: one refund paid back in cash
     *  and by card is 2 here (founder, 2026-10-29). A Z without the split by payment is in «Kredittkort». */
    totalRefundPaymentsCount(){
      return this.totalRefundCashCount + this.totalRefundCardCount + this.unclassifiedRefundCount
          + this.totalRefundBankAxeptCount + this.totalRefundBonusCount;
    },
    totalRefundReceiptsTotalAmount(){
      var amount = 0;
      for (var i = 0; i < this.zReports.length; i++) {
        amount = amount + this.zReports[i].cagistahospitality.refundReceiptsTotalAmount;
      }
      return amount;
    },
    totalRefundCashCount(){
      var count = 0;
      for (var i = 0; i < this.zReports.length; i++) {
        count = count + (this.zReports[i].cagistahospitality.refundCashCount || 0);
      }
      return count;
    },
    totalRefundCashTotalAmount(){
      var amount = 0;
      for (var i = 0; i < this.zReports.length; i++) {
        amount = amount + (this.zReports[i].cagistahospitality.refundCashTotalAmount || 0);
      }
      return amount;
    },
    totalRefundCardCount(){
      var count = 0;
      for (var i = 0; i < this.zReports.length; i++) {
        count = count + (this.zReports[i].cagistahospitality.refundCardCount || 0);
      }
      return count;
    },
    totalRefundCardTotalAmount(){
      var amount = 0;
      for (var i = 0; i < this.zReports.length; i++) {
        amount = amount + (this.zReports[i].cagistahospitality.refundCardTotalAmount || 0);
      }
      return amount;
    },
    totalRefundBankAxeptCount(){
      var count = 0;
      for (var i = 0; i < this.zReports.length; i++) {
        count = count + (this.zReports[i].cagistahospitality.refundBankAxeptCount || 0);
      }
      return count;
    },
    totalRefundBankAxeptTotalAmount(){
      var amount = 0;
      for (var i = 0; i < this.zReports.length; i++) {
        amount = amount + (this.zReports[i].cagistahospitality.refundBankAxeptTotalAmount || 0);
      }
      return amount;
    },
    totalRefundBonusCount(){
      var count = 0;
      for (var i = 0; i < this.zReports.length; i++) {
        count = count + (this.zReports[i].cagistahospitality.refundBonusCount || 0);
      }
      return count;
    },
    totalRefundBonusTotalAmount(){
      var amount = 0;
      for (var i = 0; i < this.zReports.length; i++) {
        amount = amount + (this.zReports[i].cagistahospitality.refundBonusTotalAmount || 0);
      }
      return amount;
    },
    unclassifiedRefundCount(){
      var count = 0;
      for (var i = 0; i < this.zReports.length; i++) {
        var report = this.zReports[i].cagistahospitality;
        if(report.refundReceiptsCount > 0 && report.refundCardCount === undefined && report.refundCashCount === undefined){
          count = count + report.refundReceiptsCount;
        }
      }
      return count;
    },
    unclassifiedRefundAmount(){
      var amount = 0;
      for (var i = 0; i < this.zReports.length; i++) {
        var report = this.zReports[i].cagistahospitality;
        if(report.refundReceiptsCount > 0 && report.refundCardCount === undefined && report.refundCashCount === undefined){
          amount = amount + report.refundReceiptsTotalAmount;
        }
      }
      return amount;
    }
  },
  methods: {
    displayTwoDecimals(num){
      if(num > 0 || num < 0){
        return MathUtil.displayTwoDecimals(num);
      }else {
        return num;
      }
    }
  }
}
</script>

<style scoped>
.saft-info-notice {
  font-size: 0.8em;
  color: var(--bo-muted);
  font-style: italic;
  margin-top: 4px;
}
</style>
